import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import INFTProperties, { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { IChillAFSlothsCard } from '../Card/IChillAFSlothsCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'

export default function ChillAFSlothsDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IChillAFSlothsCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)
  const tokenName = detailTokenItem ? `${collection.name} #${tokenItem.tokenId}` : collection.name
  const tokenImage = detailTokenItem ? detailTokenItem.image : ''

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTDescription() {
    return (
      <div>
        What is Chill AF Sloths?
        <p>
          ChillAF sloths are a randomly generated collection of 10,000 colorful, cool and creative sloths, with diamond
          hard claws and stone like reflexes. Made up of a random collection out of over 250 unique traits, each sloth
          is your unique little snowflake, exclusive to Avalanche C-chain Time is relative, Sloths are sedative.
        </p>
      </div>
    )
  }

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => ({
        key: item.trait_type,
        value: item.value,
        show: true,
        isUrl: false
      }))
    }

    result.push({
      key: 'External Url',
      value: `https://chillafsloths.com/sloth/${tokenItem.tokenId}`,
      isUrl: true
    })

    return result
  }

  return (
    <BaseDetail {...props} tokenItemName={tokenName} properites={getNFTProperties()} description={getNFTDescription()}>
      {detailTokenItem ? (
        <img className="chill-af-loths-image" src={tokenImage} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
